import { AuditStationPage } from '@app/modules/audit/modules/station-audit/components/AuditStationPage';
import { SchedulesViewPage } from './SchedulesViewPage';

/**
 * Wraps the schedules view page in the audit station layout for station-scoped audit routes.
 */
export function AuditSchedulesViewPageAdapter() {
  return (
    <AuditStationPage>
      <SchedulesViewPage />
    </AuditStationPage>
  );
}
